<template>
	<div class="setting">
		<div class="category">
			<div :class="'item ' + (categoryIndex == index ? 'item-select' : '')" @click="categoryChange(index)"
				v-for="(item,index) in category" :key="index">
				{{item}}
			</div>
		</div>
		<div class="block" v-show="categoryIndex===0">
			<div class="info">
				<el-form v-model="userinfo" ref="userinfo" label-width="100px">
					<el-form-item prop="avatar" label="头像:">
						<el-upload class="avatar-uploader" :action="uploadurl" :show-file-list="false"
							:on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload" accept="image/*"
							:headers="{Authtoken:Authtoken}" :data="{id:$store.state.userinfo.userId}">
							<img v-if="userinfo.avatar" :src="$pub.imageUrl+userinfo.avatar" class="avatar">
							<i v-else class="el-icon-plus avatar-uploader-icon"></i>
						</el-upload>
					</el-form-item>
					<el-form-item prop="username" label="用户名:">
						<el-input type="text" v-model="userinfo.username" placeholder="请输入用户名"></el-input>
						<el-button type="danger" size="small" plain round @click="saveUserInfo('userinfo')">保存用户名
						</el-button>
					</el-form-item>
					<el-form-item prop="phone" label="手机号:">
						<el-input v-model="userinfo.phone" placeholder="请绑定手机号" :disabled="true">
						</el-input>
						<el-button type="danger" size="small" plain round @click="editPhone">修改手机号</el-button>
					</el-form-item>
					<el-form-item prop="email" label="电子邮箱:">
						<!-- <div class="email-item" v-for="(item,index) in userinfo.email" :key="index"> -->
						<div class="email-item">
							<el-input type="email" v-model="userinfo.email" placeholder="请绑定邮箱" :disabled="true">
							</el-input>
							<el-button type="danger" size="small" plain round @click="editEmail(1)"
								v-show="!userinfo.email">添加邮箱</el-button>
							<el-button type="danger" size="small" plain round @click="editEmail(2)"
								v-show="userinfo.email">修改邮箱</el-button>
							<!-- <el-button type="danger" size="small" plain round @click="deleteEmail()"
								v-show="userinfo.email">解绑邮箱</el-button> -->
						</div>
						<!-- <el-button type="danger" size="small" plain round icon="el-icon-plus" @click="editEmail(1)">添加邮箱
						</el-button> -->
					</el-form-item>
					<el-form-item prop="password" label="登录密码:">
						<el-input type="password" v-model="userinfo.password" placeholder="请输入密码" :disabled="true">
						</el-input>
						<el-button type="danger" size="small" plain round @click="editPassword">修改密码</el-button>
					</el-form-item>
					<!-- <el-form-item>
						<el-button type="danger" round @click="saveUserInfo('userinfo')">保存信息</el-button>
					</el-form-item> -->
				</el-form>
			</div>
		</div>
		<div class="block" v-show="categoryIndex===1">
			<div class="real" v-if="userinfo.realFlag">
				<el-form v-model="realForm" :rules="realRule" ref="realForm" label-width="100px">
					<el-form-item prop="realname" label="真实姓名:">
						<el-input type="text" placeholder="请输入真实姓名" v-model="realForm.realname"
							:disabled="userinfo.realFlag"></el-input>
					</el-form-item>
					<el-form-item prop="identity" label="身份证号:">
						<el-input type="text" placeholder="请输入身份证号" v-model="realForm.identity"
							:disabled="userinfo.realFlag"></el-input>
					</el-form-item>
					<el-form-item v-if="userinfo.realFlag">
						<!-- <el-button type="danger" plain round>清除实名</el-button> -->
						<el-button type="danger" plain round @click="editReal">修改实名</el-button>
					</el-form-item>
				</el-form>
			</div>
			<div class="real" v-else>
				<el-empty description="当前未实名认证">
					<el-button type="danger" plain round @click="editReal">去实名</el-button>
				</el-empty>
			</div>
		</div>
		<div class="block" v-show="categoryIndex===2">
			<div class="address">
				<div class="add">
					<el-button type="danger" plain round @click="editAddress('')">添加地址</el-button>
				</div>
				<div class="list" v-if="address.length>0">
					<div class="item" v-for="(item,index) in address" :key="index">
						<div class="left">
							<div class="name">
								<span v-if="item.isDefaultAddress == 1">当前默认</span>
								{{item.receiverName}}&nbsp;&nbsp;
								{{item.receiverPhone}}
							</div>
							<div class="detail">
								{{item.city.split(',').join(' ')}} {{item.addressDetail}}
							</div>
						</div>
						<div class="right">
							<el-button type="danger" size="small" plain round v-if="!item.isDefaultAddress"
								@click="setDefault(item,index)">设为默认</el-button>
							<el-button type="danger" size="small" plain round @click="editAddress(item.id)">修改
							</el-button>
							<el-button type="danger" size="small" plain round @click="deleteAddress(item.id)">删除
							</el-button>
						</div>
					</div>
				</div>
				<div class="empty" v-else>
					<el-empty description="当前未添加收货地址"></el-empty>
				</div>
				<div class="pager" v-if="pageConfig.total > 12">
					<el-pagination background layout="total, prev, pager, next" :total="pageConfig.total"
						:pager-count="11" :page-size="pageConfig.pageSize" :current-page="pageConfig.currentPage"
						@current-change="pageChange">
					</el-pagination>
				</div>
			</div>
		</div>
		<div class="block" v-show="categoryIndex===3">
			<div class="like">
				<div class="like-title">
					个人偏好
				</div>
				<div class="like-search">
					<el-select v-model="tagVal" multiple filterable allow-create default-first-option
						placeholder="请选择偏好">
						<el-option v-for="item in tags" :key="item.id" :label="item.labelName" :value="item.id">
						</el-option>
					</el-select>
				</div>
				<div class="like-button">
					<el-button type="danger" round @click="saveLabel">保存</el-button>
				</div>
				<div class="like-list">
					<div class="like-empty" v-if="tagList.length == 0">
						<el-empty></el-empty>
					</div>
					<div class="like-item"
						:style="'border: 1px solid #'+(parseInt(Math.random()*0xFFFFFF).toString(16))+';color:#'+(parseInt(Math.random()*0xFFFFFF).toString(16))+';'"
						v-for="(item,index) in tagList" :key="index">
						{{item.labelName}}
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		mapMutations
	} from 'vuex'
	export default {
		name: 'setting',
		data() {
			return {
				categoryIndex: 0,
				category: [
					'个人资料',
					'实名认证',
					'收货地址管理',
					'个人偏好设置'
				],
				uploadurl: '',
				userinfo: {
					username: '',
					avatar: '',
					phone: '',
					email: '',
					password: '********',
					realFlag: false
				},
				realForm: {
					realname: '',
					identity: ''
				},
				realRule: {
					realname: [{
						required: true,
						trigger: 'blur',
						message: '请输入真实姓名'
					}],
					identity: [{
						required: true,
						trigger: 'blur',
						message: '请输入身份证号'
					}]
				},
				address: [],
				Authtoken: '',
				pageConfig: {
					total: 0,
					pageSize: 12,
					currentPage: 1
				},
				tags: [],
				tagVal: [],
				tagList: []
			};
		},
		computed: {
			getUserInfo() {
				return this.$store.state.userinfo
			}
		},
		watch: {
			getUserInfo(userInfo) {
				this.disposeUserinfo(userInfo)
			}
		},
		methods: {
			...mapMutations(['saveUserinfo']),
			categoryChange(index) {
				this.categoryIndex = index
				if (index == 2) {
					this.pageConfig.currentPage = 1
					this.fetchAddress()
				}
			},
			pageChange(e) {
				this.pageConfig.currentPage = e
				this.fetchAddress()
			},
			saveUserInfo(formName) {
				if (formName == 'userinfo') {
					this.saveUsername()
				}
			},
			saveUsername() {
				this.$api.frontRegister({
					userId: this.$store.state.userinfo.userId,
					username: this.userinfo.username
				}, res => {
					if (res.code == 200) {
						this.$parent.fetchUserInfo()
						this.$message({
							type: 'success',
							duration: 2000,
							message: '保存信息成功。'
						})
					}
				})
			},
			handleAvatarSuccess(res, file) {
				if (res.code == 200) {
					this.$api.frontAvatar({
						id: this.$store.state.userinfo.userId,
						url: res.data.fileUrl
					}, result => {
						if (result.code == 200) {
							this.$parent.fetchUserInfo()
							this.$message({
								message: '修改头像成功',
								type: 'success',
								duration: 2000
							})
						}
					})
				}
			},
			beforeAvatarUpload(file) {
				const isLt2M = file.size / 1024 / 1024 < 2;

				if (!isLt2M) {
					this.$message.error('上传头像图片大小不能超过 2MB!');
				}
				return isLt2M;
			},
			editPhone() {
				this.$router.push({
					path: '/phone'
				})
			},
			editEmail(type) {
				this.$router.push({
					path: '/email',
					query: {
						type: type
					}
				})
			},
			deleteEmail() {
				this.$confirm('确认要删除邮箱吗？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$api.frontRegister({
						email: '',
						userId: this.$store.state.userinfo.userId
					}, res => {
						if (res.code == 200) {
							this.$parent.fetchUserInfo()
							this.$message({
								message: '邮箱解绑成功！',
								duration: 2000,
								type: 'success'
							})
						}
					})
				}).catch(() => {});
			},
			editPassword() {
				this.$router.push({
					path: '/password'
				})
			},
			editReal() {
				this.$router.push({
					path: '/realname',
					type: 2
				})
			},
			editAddress(id) {
				this.$router.push({
					path: '/address',
					query: {
						id: id
					}
				})
			},
			setDefault(item) {
				this.$api.frontAddressDefault({
					id: item.id,
					isDefaultAddress: 1,
					userId: this.$store.state.userinfo.userId
				}, res => {
					if (res.code == 200) {
						this.fetchAddress()
						this.$message({
							message: '设置默认地址成功。',
							type: 'success',
							duration: 2000
						})
					}
				})
			},
			deleteAddress(id) {
				this.$confirm('确认要删除地址吗？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$api.frontAddressDelete({
						id: id,
						userId: this.$store.state.userinfo.userId
					}, res => {
						if (res.code == 200) {
							this.fetchAddress()
							this.$message({
								message: '删除地址成功。',
								type: 'success',
								duration: 2000
							})
						}
					})
				}).catch(() => {});
			},
			disposeUserinfo(userinfo) {
				this.userinfo = {
					username: userinfo.username,
					avatar: userinfo.headImg,
					phone: userinfo.phone,
					email: userinfo.email,
					password: '********',
					realFlag: userinfo.authentication == 1 ? true : false
				}
				this.realForm = {
					realname: userinfo.realName,
					identity: userinfo.idCard
				}
			},
			fetchAddress() {
				this.$api.frontAddressList({
					pageSize: this.pageConfig.pageSize,
					pageNum: this.pageConfig.currentPage,
					memberId: this.$store.state.userinfo.userId
				}, res => {
					if (res.code == 200) {
						this.pageConfig.total = res.data.total
						this.address = res.data.list
					}
				})
			},
			getLabel() {
				this.$api.frontLabelList({}, res => {
					console.log(res)
					if (res.code == 200) {
						this.tags = res.data
					}
				})
			},
			getUserLabel() {
				this.$api.frontUserLabel({
					memberId: this.$store.state.userinfo.userId
				}, res => {
					console.log(res)
					if (res.code == 200) {
						this.tagList = res.data
					}
				})
			},
			saveLabel() {
				this.$api.frontUserSaveLabel({
					labelIds: this.tagVal.join(','),
					memberId: this.$store.state.userinfo.userId
				}, res => {
					console.log(res)
					this.getUserLabel()
					if (res.code == 200) {
						this.$message({
							message: '偏好保存成功',
							type: 'success',
							duration: 2000
						})
					}
				})
			}
		},
		beforeCreate: function() {
			//生命周期 -- 组件实例刚被创建，组件属性计算之前，如DATA属性等
		},
		created: function() {
			//生命周期 -- 组件实例创建完成，属性已绑定，但DOM还未生成，$el属性还不存在
			this.uploadurl = this.$pub.requestUrl + 'AvatarApi/uploadAvatar'
			this.Authtoken = this.$pub.getStorage('page_token')
			this.disposeUserinfo(this.$store.state.userinfo)
		},
		beforeMount: function() {
			//模板编译/挂载之前
		},
		mounted: function() {
			//模板编译/挂载之后
			this.getLabel()
			this.getUserLabel()
		},
		beforeUpdate: function() {
			//组件更新之前
		},
		updated: function() {
			//组件更新之后
		},
		activated: function() {
			// for keep-alive，组件被激活时调用
		},
		deactivated: function() {
			// for keep-alive，组件被移除时调用
		},
		beforeDestory: function() {
			// 组件销毁调用
		},
		destoryed: function() {
			// 组件销毁后调用
		}
	};
</script>

<style lang="less" scoped="scoped">
	.category {
		width: 100%;
		height: 50px;
		display: flex;
		border-bottom: 2px solid @vue-border-color-red;

		.item {
			width: 20%;
			height: 50px;
			display: flex;
			justify-content: center;
			align-items: center;
			cursor: pointer;
		}

		.item-select,
		.item:hover {
			background: @vue-bg-color-red;
			color: @vue-text-color-inverse;
		}
	}

	.avatar-uploader .el-upload {
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 178px;
		height: 178px;
		line-height: 178px;
		text-align: center;
		border: 1px dashed #d9d9d9;
	}

	.avatar {
		width: 178px;
		height: 178px;
		display: block;
	}

	.info,
	.real {
		width: 100%;
		padding: @vue-spacing-col-lg*2 @vue-spacing-row-lg;
		box-sizing: border-box;

		.el-input {
			width: 500px;
			margin-right: @vue-spacing-row-base;
		}

		.email-item {

			// margin-bottom: @vue-spacing-col-base;
			.el-button:nth-child(2),
			.el-button:nth-child(3) {
				margin-left: 0px;
			}
		}
	}

	.address {
		width: 100%;
		padding: @vue-spacing-col-lg @vue-spacing-row-lg;
		box-sizing: border-box;

		.add {
			width: 100%;
			height: 70px;
			display: flex;
			justify-content: flex-end;
			align-items: center;
		}

		.list {
			width: 100%;
			border: 1px solid @vue-border-color-red;
			box-sizing: border-box;

			.item {
				width: 100%;
				border-bottom: 1px solid @vue-border-color-red;
				padding: @vue-spacing-col-base @vue-spacing-row-lg;
				box-sizing: border-box;
				display: flex;
				justify-content: space-between;

				.left {
					width: calc(100% - 240px);

					.name {
						width: 100%;
						height: 40px;
						display: flex;
						align-items: center;

						span {
							background: @vue-bg-color-red;
							color: @vue-text-color-inverse;
							border-radius: 24px;
							padding: 3px 10px;
							margin-right: @vue-spacing-row-base;
							font-size: @vue-font-size-sm - 2;
						}
					}

					.detail {
						width: 100%;
						line-height: 30px;
					}
				}

				.right {
					width: 240px;
					height: 40px;
					display: flex;
					align-items: center;
					justify-content: flex-end;
				}
			}

			.item:last-child {
				border: none;
			}
		}

		.pager {
			width: 100%;
			height: 70px;
			display: flex;
			justify-content: center;
		}
	}

	.like {
		width: 100%;

		.like-title {
			width: 100%;
			height: 80px;
			display: flex;
			justify-content: center;
			align-items: center;
			font-size: @vue-font-size-base;
		}

		.like-search {
			width: 100%;
			display: flex;
			justify-content: center;

			.el-select {
				width: 600px;
			}
		}

		.like-button {
			width: 100%;
			height: 80px;
			display: flex;
			align-items: center;
			justify-content: center;

			.el-button {
				width: 200px;
			}
		}

		.like-list {
			width: 100%;
			padding: @vue-spacing-col-lg;
			display: flex;
			flex-wrap: wrap;
			
			.like-empty{
				width: 100%;
				display: flex;
				justify-content: center;
			}

			.like-item {
				padding: @vue-spacing-col-sm @vue-spacing-row-base;
				box-sizing: border-box;
				line-height: 20px;
				box-sizing: border-box;
				border-radius: @vue-border-radius-base;
				margin-right: @vue-spacing-row-base;
				margin-bottom: @vue-spacing-col-base;
			}
		}
	}
</style>
